var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandfillWaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#FB6F4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.421 80.5078H34.7394C33.6304 80.5105 32.5395 80.2742 31.5724 79.822C30.6053 79.3698 29.7949 78.7169 29.2198 77.9268C28.6676 77.1332 28.3755 76.2324 28.3731 75.315C28.3706 74.3977 28.6578 73.4959 29.2058 72.7002L43.1101 52.6758M43.1101 52.6758L46.9667 64.6758M43.1101 52.6758L28.7101 55.8926M56.4835 80.5078H85.3222C86.4258 80.5007 87.5087 80.2571 88.4667 79.8005C89.4247 79.3438 90.2256 78.6895 90.7925 77.9004C91.3371 77.109 91.6237 76.2126 91.6237 75.3003C91.6237 74.388 91.3371 73.4916 90.7925 72.7002L86.4823 66.4893M56.4835 80.5078L67.0304 71.7188M56.4835 80.5078L67.0304 89.2969M50.6616 41.8682L54.5042 36.3252C55.056 35.5236 55.847 34.8545 56.8005 34.3828C57.7541 33.911 58.8377 33.6527 59.9464 33.6328C61.0466 33.6311 62.1279 33.8706 63.0819 34.3272C64.0359 34.7839 64.829 35.4416 65.3815 36.2344L79.2437 56.2822M79.2437 56.2822L64.8437 53.0654M79.2437 56.2822L83.1003 44.2822",
    stroke: "#FCFEFF",
    strokeWidth: 5.85937,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandfillWaste);
export default __webpack_public_path__ + "static/media/landfill-waste.f840200439e884036e045b127e7dc7e7.svg";
export { ForwardRef as ReactComponent };